import axios from 'axios'
import {urlIsQiNiu} from '@/utils/index'
import {getImgApiHost} from '@/utils/config'
import {getOssImg} from '@/api'

export function openURL(key) { //api/utils/
  // const url = urlIsQiNiu(key)?"download/token/?keys=":"oss/download/token/?keys="
  // 骑牛的继续骑牛 getImgApiHost, 阿里的请求地址换成 getApiHost
  if (urlIsQiNiu(key)) {
    axios({
      url: getImgApiHost() + "download/token/?keys=" + key,
      method: 'get',
      dataType: "json"
    }).then(res=>{
      const d = res.data;
      if(d.status == 0){
        let url = d.data.urls[0].url;
        console.log("--- qiniu open ---");
        console.log(url);
        window.open(url);
      }
    });
  } else {
    let arr_str = JSON.stringify([decodeURIComponent(key)]);
    console.log(arr_str);
    getOssImg({keys: arr_str}).then(res => {
      if(res.status == 0){
        let url = res.data.urls[0].url;
        console.log("--- oss open ---")
        console.log(url);
        window.open(url);
      }
    });
  }
}
